import { requestDelete, requestGet, requestPost } from '@/utils/request';
import { TCustomField, TDynamicFormConfig } from '@/components/DynamicForm/model';

/**
 * 列出自定义字段
 * @param campId 打卡营ID
 * @returns
 */
export const listCustomField = async (campId: string) => {
  return requestGet(`/v2/camp/api/dynamic/form/${campId}/custom/field`, {});
};

/**
 * 创建或修改自定义字段
 * @param data
 */
export const upsertCustomField = async (data: TCustomField) => {
  return requestPost(`/v2/camp/api/dynamic/form/custom/field`, data);
};

/**
 * 获取报名表单配置
 * @param campId 打卡营ID
 */
export const getDynamicForm = async (campId: string) => {
  return requestGet(`/v2/camp/api/dynamic/form/${campId}/config`, {});
};

/**
 * 新增或修改报名表单配置
 * @param data
 */
export const upsertDynamicForm = async (data: TDynamicFormConfig) => {
  return requestPost(`/v2/camp/api/dynamic/form`, data);
};

/**
 * 删除自定义字段
 * @param id
 */
export const removeCustomField = async (id: number) => {
  return requestDelete(`/v2/camp/api/dynamic/form/custom/field/${id}`, {});
};
